import { InputText } from 'primereact/inputtext';

const BaseInputText = (props)=>{
    return <InputText {...props}></InputText>
}

export default BaseInputText;